'use strict';

angular
  .module('cfn')
  .factory('newsletterSubscriptionService', newsletterSubscriptionService);

newsletterSubscriptionService.$inject = ['$http'];

function newsletterSubscriptionService($http) {
  return {
    resendConfirmationMail: resendConfirmationMail,
    setNewsletterStatus: setNewsletterStatus,
    getNewsletterStatus: getNewsletterStatus,
  };
  
  function resendConfirmationMail() {
    return this.setNewsletterStatus(true);
  }

  function setNewsletterStatus(newStatus) {
    if (newStatus) {
      return $http.put('/365FarmNet/mod/signon/rest/v1.0/commercial-contact/newsletters-agreements', {
        processType: 'NEWSLETTER'
      });
    } else {
      return $http.delete('/365FarmNet/mod/signon/rest/v1.0/commercial-contact/newsletters-agreements');
    }
  }

  function getNewsletterStatus() {
    return $http.get('/365FarmNet/mod/signon/rest/v1.0/commercial-contact/newsletters-agreements');
  }
}
